import React from 'react';
import AdminDashboard from 'screens/dashboard/AdminDashboard';
import UserRoute from 'components/Routes/UserRoute';

const routes = [
  <UserRoute key="dashboard" path="/dashboard"><AdminDashboard/></UserRoute>
];

export default routes;
